import { t as e } from "./dist-B3lndwlS.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-visually-hidden@1.2.8_@types+react-dom@19.2.3_@types+react@19.2.17__@ty_bcd4d94cbdcbc9c64a864523b5b4f900/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
var r = Object.defineProperty, i = (e, t) => r(e, "name", {
	value: t,
	configurable: !0
}), a = Object.freeze({
	position: "absolute",
	border: 0,
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	wordWrap: "normal"
}), o = /* @__PURE__ */ t.forwardRef(/* @__PURE__ */ i(function(t, r) {
	return /* @__PURE__ */ n(e.span, {
		...t,
		ref: r,
		style: {
			...a,
			...t.style
		}
	});
}, "VisuallyHidden"));
//#endregion
export { a as n, o as t };

//# sourceMappingURL=dist-Bl9r4eY0.js.map